import React, { FC } from 'react';
import { Card } from '@components/atoms/Card';
import styles from './ProductCategoryCard.module.css';
import { Anchor, AnchorMode } from '@components/atoms/Anchor';

export interface ProductCategoryCardProps {
    name?: string;
    image?: string;
    active?: boolean;
    href: string;
}

export const ProductCategoryCard: FC<ProductCategoryCardProps> = ({ name, image, active, href }) => {
    return (
        <Anchor href={href} mode={AnchorMode.none}>
            <Card classes={`${styles['product-category-card']} ${active ? `active ${styles.active}` : ''}`}>
                <>
                    {image && (
                        <div className="position-relative">
                            <Card.ImageOverlay active={active} />
                            <img src={image} alt={name} />
                        </div>
                    )}
                </>
                <div className="card-body text-center px-0">
                    <Card.Title
                        typography={{
                            classes: styles['title'],
                            color: 'dark',
                            fontSize: '16',
                            fontWeight: '900',
                            children: name,
                        }}
                    />
                </div>
            </Card>
        </Anchor>
    );
};
